export const MAP_POINTS_QUERY_KEY = "map_points"
